console.log("Enviroment: ", process.env.NODE_ENV);

// production
const production = {
  url: {
    API_URL: "https://whatstv-api.herokuapp.com",
    API_WEBHOOK_BASE: "https://whatstv-api.herokuapp.com/v1/",
    PODCAST_WS_URL: "https://whatstv-api.herokuapp.com",
  },
};

// development heroku
const sqa = {
  url: {
    API_URL: "https://whatstv-api-develop.herokuapp.com",
    API_WEBHOOK_BASE: "https://whatstv-api.herokuapp.com/v1/",
    PODCAST_WS_URL: "https://whatstv-api-develop.herokuapp.com",
  },
};

// development local
const development = {
  url: {
    API_URL: process.env.REACT_APP_API_URL || "https://whatstv-api.herokuapp.com",
    // Socket sempre aponta para produção (onde chegam os webhooks WhatsApp);
    // override via REACT_APP_SOCKET_URL só se precisar testar socket local.
    SOCKET_URL: process.env.REACT_APP_SOCKET_URL || "https://whatstv-api.herokuapp.com",
    API_WEBHOOK_BASE: process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL}/v1/`
      : "https://whatstv-api.herokuapp.com/v1/",
    PODCAST_WS_URL: process.env.REACT_APP_API_URL || "https://whatstv-api.herokuapp.com",
  },
};

var choose = undefined;
if (process.env.REACT_APP_ENVIROMENT === "production") {
  choose = production;
} else if (process.env.REACT_APP_ENVIROMENT === "develop") {
  choose = sqa;
} else {
  choose = development;
}

export const config = choose;
